<template lang="pug">
    .page
      div(v-if="alert.loading")
        section.d-flex.align-items-center.justify-content-center
          b-spinner(type="grow")
      div(v-else="")
        .container-fluid.p-5
          b-button(@click="closePiece()")
            font-awesome-icon.mr-2(icon="caret-left")
            span RETURN
        section.pt-1
          .container
            .row
              .col-md-8.d-flex.align-items-center
                img.img-main.pointer(:src="piece.images.preview[0].url", @click='index = 0', :alt="`${piece.title} by ${piece.artist}`")
              .col-md-4
                h2 {{ piece.title }}
                p {{ `by ${piece.artist }` }}
                // .frame-select
                hr
                h4.mt-1.d-inline {{ formatRands(piece.price) }}
                div.pt-3
                  ul.list-unstyled
                    li
                      span.font-weight-bold Medium
                      span.ml-1 {{ `${piece.form} | ${piece.medium}` }}
                    li
                      span.font-weight-bold Style
                      span.ml-1 {{ piece.style }}
                    li
                      span.font-weight-bold Subject
                      span.ml-1 {{ piece.subject }}
                    li
                      span.font-weight-bold Framed
                      span.ml-1 {{ piece.framed?'Yes':'No' }}
                    li
                      span.font-weight-bold Dimensions
                      span.ml-1 {{ `${piece.height} x ${piece.width}cm` }}
                    li
                      span.font-weight-bold Ready to hang
                      span.ml-1 {{ piece.ready_to_hang?'Yes':'No' }}
                    li(v-if="piece.collection_size > 1")
                      span.font-weight-bold Collection
                      span.ml-1 {{ `One of ${piece.collection_size}` }}
                    li(v-if="piece.materials")
                      span.font-weight-bold Materials
                      span.ml-1 {{ piece.materials }}
                hr
                p {{ piece.description }}
                div(v-if="piece.status === 'rented'")
                  b-button(:to="{ name: 'contact'}")
                    span(href="") This piece is currently rented out, please
                    b-link.text-muted.mx-2(:to="{name: 'contact'}") Contact Us
                    span(href="") to enquire further
                div(v-else-if="piece.status === 'sold'")
                  b-button(:to="{ name: 'gallery'}")
                    span(href="") This piece is has been sold
                div(v-else-if="piece.status === 'reserved'")
                  b-button(:to="{ name: 'gallery'}")
                    span(href="") This piece is has been reserved
                div(v-else-if="!checkCartForItem(piece.product_id)")
                  b-collapse#buyButtons(:visible="true")
                    b-button#btnBuy.btn-dark.btn-block(@click='addToCart(piece)') BUY
                    b-button#btnRent.btn-light.btn-block(v-if="piece.is_rentable", @click="stageRental(piece)") {{ `RENT FOR ${formatRands(piece.price_rental)}/m` }}
                div(v-else="")
                  b-button.btn-dark.btn-block(:to="{name: 'cart'}") CHECKOUT
                  b-button.btn-light.btn-block(@click="removeFromCart(piece.product_id)") REMOVE FROM CART
                div.mt-3
                  router-link.text-muted.small.d-block(:to="{name: 'help'}") How does renting work?
                  router-link.text-muted.small.d-block(:to="{name: 'help'}") Delivery & Returns
        section.vr-view.p-0.d-none.d-md-block
          .controls
            b-form
              .container
                p For preview only. Not to scale.
                b-form-row
                  b-col
                    label Wall
                  b-col
                    b-form-input(type='range', min=0, max=255, step=1, number, v-model='previewParams.wallShade')
                b-form-row
                  b-col
                    label Frame
                  b-col
                    b-form-input(type='range', min=0, max=30, step=1, number, v-model='previewParams.frameWidth')
                b-form-row
                  b-col
                    label Gutter
                  b-col
                    b-form-input(type='range', min=0, max=30, step=1, number, v-model='previewParams.gutterWidth')
                b-form-row
                  b-col
                    label Lights
                  b-col
                    b-form-checkbox(switch, v-model='lightsOut')
          img.bg(src="@/assets/images/backgrounds/blank-wall.png")
          .wall(:style="wallStyle")
            .light.light1
            .light.light2
            .light.light3
            .light.light4
          //img.lamp(src="@/assets/images/lamp.svg")
          img.lamp-light(src="@/assets/images/lamp_light.svg", :class="{ 'lights-out' : !(!lights && lightsOut) }")
          .frame(v-if="piece", :style="frameStyle")
            img.piece(:src="piece.images.preview[0].url",:style="gutterStyle")
          .overlay.overlay-top(:class="{ 'lights-out' : lights }")
          .overlay.overlay-bottom(:class="{ 'lights-out' : lightsOut }")
        section.bg-light
          CoolLightBox(:items='fullImages' :index='index' @close='index = null')
          b-container
            .row
              .col-md-4.center-xy.px-3.pb-3(v-for='(image, imageIndex) in previewImages', :key='imageIndex')
                img.pointer.w-100.w-md-75(:src="image", @click='index = imageIndex')
            //- VueSlickCarousel(:arrows="true" :dots="true", :rows='2', :slidesPerRow='3')
              div(v-for='(image, imageIndex) in images', :key='imageIndex')
                img.slider-image.mx-auto(:src="image", @click='index = imageIndex')
        section.section-artist
          b-container
            .row
              .col-md-4
                h1 ABOUT
                  br
                  | THE
                  br
                  | ARTIST
                b-button.btn-outline(:to="{name: 'gallery', query: { artist: piece.artist_id }}") + OTHER WORK
              .col-md-8
                h2.mt-md-0 {{ piece.artist }}
                p {{ piece.artist_base }}
                p {{ piece.artist_bio }}
        section.bg-light
          .container.text-center
            h2 Hesitant to buy before seeing the real thing?
            p Don’t pass up the opportunity to own a beautiful and authentic artwork, only because you haven’t had a chance to experience the piece in reality. Our rental service allows you start by testing the unique piece at a fraction of the purchase price.
            // p {{ `You can rent ${piece.title} for ${formatRands(piece.price_rental)}/m to see how it feels in your space.` }}
            b-button#btnRent.btn-outline(v-if="piece.is_rentable && piece.collection_size === 1", @click="stageRental(piece)") {{ `RENT FOR ${formatRands(piece.price_rental)}/m` }}
        //- section.bg-view.p-0.d-md-none.d-block(:style="{'background-image': `url(${piece.images[0].url})`}")
</template>

<script>

import { ContentLoader } from 'vue-content-loader';
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex';
import { apiService } from '@/services';
import standardMix from '@/mixins/standardMix';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import router from '@/router';

import CoolLightBox from 'vue-cool-lightbox';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';

export default {
  name: 'Events',
  metaInfo() {
    return {
      title: `${this.piece.title} by ${this.piece.artist}`,
      // meta: [{
      //   name: 'description',
      //   content: 'I will not be',
      // }],
    };
  },
  mixins: [standardMix],
  components: {
    ContentLoader,
    VueSlickCarousel,
    CoolLightBox,
  },
  data() {
    return {
      piece: { title: ' ' },
      previewImages: [],
      showDetails: false,
      rentForm: {
        months: 6,
      },
      images: [],
      index: null,
      previewParams: {
        wallShade: 255,
        frameShade: '',
        frameWidth: 15,
        gutterWidth: 10,
        paintingWidth: 20,
      },
      lightsOut: false,
      lights: false,
    };
  },
  computed: {
    ...mapState('resource', ['events']),
    ...mapState('cart', ['cart']),
    ...mapGetters('cart', ['checkCartForItem']),
    frameStyle() {
      return {
        borderWidth: `${this.previewParams.frameWidth}px`,
        width: `${this.previewParams.paintingWidth}%`,
        left: `${48 - ((this.previewParams.paintingWidth - 20) / 2)}%`,
      };
    },
    gutterStyle() {
      return {
        borderWidth: `${this.previewParams.gutterWidth}px`,
      };
    },
    wallStyle() {
      return {
        background: `rgb(${this.previewParams.wallShade},${this.previewParams.wallShade},${this.previewParams.wallShade})`,
      };
    },
  },
  watch: {
    lightsOut(val) {
      this.lights = val;
      if (val) {
        setTimeout(() => { this.lights = !val; }, 2000);
      }
    },
  },
  methods: {
    ...mapActions('resource', ['getResource']),
    // ...mapActions('cart', ['addToCart']),
    ...mapMutations('cart', ['removeFromCart', 'stageRental', 'addToCart']),
    closePiece() {
      window.close();
    },
  },
  async created() {
    if (this.$route.params.pieceId !== 0) {
      try {
        this.loading();
        this.piece = await apiService.getPiece(this.$route.params.pieceId);
        this.previewImages = this.piece.images.preview.map(item => item.url);
        this.fullImages = this.piece.images.full.map(item => item.url);
        // Hack to fill dummy images
        // if (this.images.length < 3) {
        //   this.previewImages.push(this.previewImages[0]);
        //   this.previewImages.push(this.previewImages[0]);
        //   this.fullImages.push(this.fullImages[0]);
        //   this.fullImages.push(this.fullImages[0]);
        // }
        this.clear();
      } catch (error) {
        router.push({ name: 'gallery' });
        // this.error('Piece no longer available');
      }
    }
  },
};
</script>

<style lang="scss" scoped>
  .img-main {
    max-width: 100%;
    max-height: 90vh;
    // border: 10px solid black;
  }
  .img-main-placeholder {
    border: 1px solid rgb(168, 163, 163);
    max-width: 100%;
    height: 90vh;
  }

  .slick-slider {
    img {
      height: 250px;
      cursor: pointer;
    }
    .slick-arrow {
      color: red;
    }
  }

  .section-artist {
    img {
      height: 200px;
    }
  }
  .bg-view {
    background-size: cover;
    height: 500px;
  }
  .vr-view {
    position: relative;
    width: 100vw;
    z-index: 0;
    .controls {
      display: none;
      @include desktop {
        display: block;
        z-index: 1000;
        position: absolute;
        left: 10px;
        top: 10px;
      }
    }
    .bg {
      z-index: 1;
      width: 100%
    }
    .overlay {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      opacity: 0;
      background-color: black;
      transition: 1s ease-out;
      &.overlay-bottom {
        z-index: 3;
        &.lights-out {
          opacity: 0.8;
        }
      }
      &.overlay-top {
        z-index: 7;
        &.lights-out {
          opacity: 0.8;
        }
      }
    }
    .lamp {
      z-index: 6;
      position: absolute;
      left: 57%;
      top: 30%;
      width: 2%;
    }
    .lamp-light {
      z-index: 5;
      position: absolute;
      left: 53%;
      top: 32%;
      width: 10%;
      opacity: 1;
      &.lights-out {
        opacity: 0;
      }
    }
    .wall {
      z-index: 2;
      overflow: hidden;
      background-color: white;
      position: absolute;
      width: 47.5%;
      height: 55.6%;
      left: 33.6%;
      top: 26.8%;
      -webkit-box-shadow: inset -4px -3px 15px 1px rgba(0,0,0,0.07);
      box-shadow: inset -4px -3px 15px 1px rgba(0,0,0,0.07);
      .light {
        position: absolute;
        border-radius: 50%;
        background-color: white;
        filter: blur(50px);
        opacity: 0.5;
        &.light1{
          left: 0%;
          top: -10%;
          width: 20%;
          height: 20%;
        }
        &.light2{
          left: 30%;
          top: -10%;
          width: 20%;
          height: 20%;
        }
        &.light3{
          left: 57%;
          top: -10%;
          width: 20%;
          height: 20%;
        }
        &.light4{
          left: 80%;
          top: -10%;
          width: 20%;
          height: 20%;
        }
      }
    }
    .frame {
        z-index: 4;
        position: absolute;
        width: 20%;
        top: 54%;
        left: 48%;
        transform: translateX(-50%);
        transform: translateY(-50%);
        border: 10px solid rgba(0,0,0,1);
        border-left: 10px solid #111;
        border-bottom: 10px solid #222;
        border-right: 10px solid #333;
        border-radius: 1px;
        box-shadow: 2px 1px 5px #000;
      .piece {
        width: 100%;
        position: relative;
        border: 10px solid #FFF;
        border-top: 10px solid #DDD;
        border-left: 10px solid #EEE;
        border-right: 10px solid #f0f0f0;
        // display: block;
        // box-shadow: 5px 0 20px #000;
        //   border: 10px solid #000;
        // border-left: 10px solid #111;
        // border-bottom: 10px solid #222;
        // border-right: 10px solid #333;
        // border-radius: 1px;
        // box-shadow: inset 2px 1px 5px #000;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Piece.vue